import React from "react";
import Tool from "./Tool";

export default class TextTool extends Tool {
  constructor(props) {
    super(props, 20, 20, "text");
  }

  renderTool() {
    return (
      <polygon points='0,0 20,0 20,6 17,6 17,3 11,3 11,17 16,17 16,20 4,20 4,17 9,17 9,3 3,3 3,6 0,6' />
    );
  }

  getCursor() {
    return 'text'
  }
}



// WEBPACK FOOTER //
// ./src/components/ui/tools/TextTool.js